// 1–3 星（代码绘制的内联 SVG：金色填充 + 深棕描边；没得到的星是浅纸色凹印）。结算条 / 地点卡 / 图鉴 / 每日挑战共用。
import type { LevelMods } from '../core/levels';

const SVG_NS = 'http://www.w3.org/2000/svg';
/** 圆角五角星（viewBox 0 0 24 24） */
const STAR_PATH =
  'M12 2.6l2.75 5.86 6.4.78-4.72 4.4 1.22 6.33L12 16.86 6.35 19.97l1.22-6.33-4.72-4.4 6.4-.78z';

function starSvg(): SVGSVGElement {
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('aria-hidden', 'true');
  const p = document.createElementNS(SVG_NS, 'path');
  p.setAttribute('d', STAR_PATH);
  p.setAttribute('stroke-linejoin', 'round');
  svg.append(p);
  return svg;
}

/** 往容器里填 3 颗星，前 got 颗点亮；容器上记 data-stars 便于测试 */
export function fillStars(box: HTMLElement, got: number): void {
  box.replaceChildren();
  box.dataset.stars = String(got);
  box.setAttribute('aria-label', `${got} 星`);
  for (let i = 0; i < 3; i++) {
    const s = document.createElement('i');
    s.className = i < got ? 'is-on' : '';
    s.style.setProperty('--i', String(i));
    s.append(starSvg());
    box.append(s);
  }
}

export function starsEl(got: number, cls = ''): HTMLElement {
  const box = document.createElement('span');
  box.className = `stars ${cls}`.trim();
  box.setAttribute('role', 'img');
  fillStars(box, got);
  return box;
}

/** 关卡玩法的小标签文字（地点卡 / 每日挑战页）；没有玩法 = 空 */
export function modLabels(m: LevelMods): { kind: 'rotate' | 'flip'; text: string }[] {
  const out: { kind: 'rotate' | 'flip'; text: string }[] = [];
  if (m.rotate) out.push({ kind: 'rotate', text: '旋转' });
  if (m.flip) out.push({ kind: 'flip', text: '翻面' });
  return out;
}
